import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Text } from '@uhg-abyss/web/ui/Text';
import React from 'react';

/**
 * MenuItem
 *
 * Renders an icon and title for usage in a navigation component.
 *
 * @param iconName
 * @param title
 * @returns {Element}
 * @constructor
 */
export function MenuItem({ iconName, title }) {
  return (
    <ErrorHandler location="src/layouts/Application/sections/Header/components/Navigation/components/MenuItem/MenuItem.jsx">
      <div className="nav-icon-wrap">
        <IconSymbol icon={iconName} />
        <Text>{title}</Text>
      </div>
    </ErrorHandler>
  );
}
